export default __webpack_public_path__ + "static/media/illustration-study-1-m@3x.3ad7cc2e.webp";